import type {PropositionConfig, ContractSchema} from '@myparcel-frontend/proposition';
import {getProposition} from '@myparcel-frontend/proposition';
import {toConfigKey, CarrierId} from '@myparcel-frontend/types';
import useFeatures from '../../composables/useFeatures';
import useAcl from '@/composables/useAcl';
import {useEnvironmentStore} from '@/env/useEnvironmentStore';

const filterCustomCarriers = (customCarriers: (typeof ContractSchema)[]): (typeof ContractSchema)[] => {
  const {isFeatureActive} = useFeatures();

  return customCarriers.filter((contract) => {
    // Add carriers to filter out here based on feature flags

    // if (contract.carrier.id === CarrierId.Example) {
    //   return isFeatureActive('carrierContracts.Example');
    // }

    return true;
  });
};

export const getPropositionConfig = async (): Promise<PropositionConfig> => {
  const {acl} = useAcl();
  const {environment} = useEnvironmentStore();

  const configKey = toConfigKey(acl.value.platform_id);
  if (!configKey) {
    throw new Error('No config found for hostname. Please check the host mapping.');
  }

  const propositionConfig = await getProposition(configKey, environment.environment);
  propositionConfig.assets.url = environment.assetsUrl;

  propositionConfig.contracts.availableForCustomCredentials = filterCustomCarriers(
    propositionConfig.contracts.availableForCustomCredentials,
  );

  return propositionConfig;
};
